export default {
    hero: {
        title: 'Moe tijdens of na behandeling van kanker?',
    },
    intro: {
        title: 'Veel mensen hebben last van vermoeidheid tijdens en na de behandeling van kanker.',
        text: 'Bij een groot deel van de mensen trekt deze vermoeidheid na enkele maanden weg. Bij een ander deel blijft de moeheid bestaan en lukt het niet meer om alle activiteiten op te pakken. We spreken in dat geval van (chronische) vermoeidheid na kanker. <br/><br/>Wil je weten hoe ernstig jouw vermoeidheidsklachten zijn? Tips hoe je met vermoeidheid om kunt gaan? Advies voor een eventuele behandeling? Test jezelf hier.',
        card1: {
            title: 'Test jezelf. Makkelijk en veilig.',
            text: 'Wil je weten hoe ernstig jouw vermoeidheidsklachten zijn? Deze test brengt snel je vermoeidheidsklachten in kaart. Daarnaast krijg je advies hoe je het beste met je vermoeidheid om kunt gaan.',
        },
        card2: {
            title: 'Gewoon moe of chronisch moe?',
            text: `
            Is je vermoeidheid <strong class="text-white">niet</strong> begonnen in de periode dat je behandeld werd voor kanker? Op <a class="text-white font-weight-bold text-underline" href="/">deze website</a> vind je de algemene vermoeidheidstest.
            `,
        },
    },
    slider: {
        title: 'Ervaringen van anderen',
        text: 'Hoe ervaren anderen hun vermoeidheid en hoe gaan ze ermee om? Misschien herken je jezelf in een van de verhalen die je hier leest.',
        nextStory: 'Naar het volgende verhaal',
    },
};
